const ALL_QUESTIONS = 'ALL'
const ONE_QUESTION = 'ONE'

export default {
  ALL: ALL_QUESTIONS,
  ONE: ONE_QUESTION
}
